module.exports = __webpack_public_path__ + "img/cropper-example003.b88c2a37.png";